import React, {Component} from 'react'
import Question from './Question'
import Sidebar from './Sidebar'
import {getTopic,getTest,getStats,getPartIIQuestion} from './AnswerFormats'

export default class Quiz extends Component {

    state = {
        PTable:"hide",
        showAll:false,
    };

    constructor(props){
      super(props);
      const {topic,exclude}=this.props;
      //topic=[[1,0],[1,1],[2,1],etc.] or "Stoichiometry", exclude=[{year:2020,test:"L"},{year:2019,test:"N"},etc]
      this.state.questions=[];
      this.state.topic=this.getNames(topic,exclude)
      this.state.topicquestions=this.props.PartII ? this.getQuestions(topic) : this.sortQuestions(this.trimQuestions(this.getQuestions(topic)));
      this.state.stats=getStats();
    }  

    trimQuestions = (questions) => {
      const questionSet = [];
      let index=0;
      for (let i=0;i<questions.length;i++){
        let q=questions[i];
        let keep = true;
        for (let j=0;j<questionSet.length;j++){
          let Q=questionSet[j];
          if (Q.number===q.number&&Q.test===q.test&&Q.year===q.year){
            keep = false;
            break;
          }
        }
        if (keep) questionSet[index++]=q;
      }
      return questionSet;
    }

    sortQuestions = (questions) => {
      return questions.sort((E1,E2)=>{
        if (E1.year===E2.year){
            if (E1.test===E2.test){
              return E1.number-E2.number;
            }
            return E1.test==="N" ? 1 : -1;
        }
        return E2.year-E1.year;
      });
    }



    componentDidMount(){
      this.randomQuestion(false);
    }

    componentDidUpdate(){
      localStorage.setItem('stats',JSON.stringify(this.state.stats));
      //console.log("storage updated")
    }

    getNames = (topic,exclude) => {
      const names= topic.map((t,i) => {
        let and = " AND ";
        if (i===topic.length-1) and="";
        //if (this.props.PartII) return t+and;
        return (getTopic(t).name+and);
      });
      const excluded = exclude.map((t) => {
        let test="Local";
        if (t.test==="N")test="USNCO";
        return (" NOT "+t.year+" "+test);
      })

        return <div className = "topicNames">{names} {excluded}</div>
    }
    
    getQuestions = (topic) => {
      const topics = topic.map(t => getTopic(t).topic);
      let questions=[];

      let n = topics.length;
      for (let i=0;i<n;i++){
        
        let m=topics[i].length;
        for (let j=0;j<m;j++){

        if (this.props.PartII){
          questions.push({year:topics[i][j][0], number:topics[i][j][1]})
          continue;
        }

          let test=getTest(j,true);
          let skip=this.props.exclude.some(element => test.year===element.year&&test.test===element.test);

          if (!skip)topics[i][j].forEach(v=>questions.push({year:test.year,number:v,test:test.test}));
        }
      }
      return questions;
    }

    isExcluded = (year,test) => {
      const { exclude }=this.props;
      for (let i=0;i<exclude.length;i++){
      if (year===exclude[i].year&&test===exclude[i].test)return true;
      }
      return false;
    }

    randomQuestion = (keepprevious) => {
      let n = this.state.topicquestions.length;
      if (n===0) {
        this.noMoreQuestions();
        return;
      }
      let i = Math.floor(Math.random()*n);
      let questions;
      if (keepprevious) questions=[...this.state.questions,this.state.topicquestions[i]];
      else questions=[this.state.topicquestions[i]];
      this.setState({
        questions: questions,
        topicquestions:this.state.topicquestions.filter((q,index) => { return index!==i})});
    }

    answer = (correct,categories) => {
      this.setState(prevState => {
        let index = correct ? 0 : 1;
        let updatedStats = {};
        Object.assign(updatedStats,prevState.stats);
        //console.log(prevState.stats);
        categories.forEach((v) => {
            updatedStats[v][index]++;
        })
        //console.log("answered - " + categories);
        return {stats: updatedStats};
      });
    }

    resetStats = () => {
      localStorage.setItem('stats','{}');
    }

    deleteStats = () => {
      localStorage.removeItem('stats');
    }



    noMoreQuestions = () => {
      window.alert("No more questions")
    }

    showPTable = () => {
      if (this.state.PTable==="hide") this.setState({PTable:""});
      else this.setState({PTable:"hide"})
    }

    showAll = () => {
      this.setState({
        topicquestions: this.props.PartII ? this.getQuestions(this.props.topic) : this.sortQuestions(this.trimQuestions(this.getQuestions(this.props.topic))),
        questions : [],
        showAll:true,
      })
      this.showMore();
    }

    showMore = () => {
        let {topicquestions,questions} = this.state;
        const lastQuestionIndex = Math.min(10,topicquestions.length);
        const newQuestions = topicquestions.slice(0,lastQuestionIndex);
        questions = questions.concat(newQuestions);
        this.setState({
          questions: questions,
          topicquestions: topicquestions.filter((v,i)=>{return i>=lastQuestionIndex})
        })

    }

    hideQuestion = (index) => {
      const Qslice = this.state.questions.slice();
      this.setState({questions:Qslice.filter((v,i)=> i!==index)})
    }
    
    render() {
        const {topic} = this.state;
        const partIQuestions = this.state.questions.map((q,i) => {return (
          <Question 
            data={q} 
            key={q.year+" "+q.test+" "+q.number}
            hide={() => this.hideQuestion(i)}
            answer={this.answer}
            />
            );
        });

        const PartIIQuestions = this.state.questions.map((q,i) => {
          const individualQuestion = getPartIIQuestion(q);

          return (
          <div className = "aQuestion">
              <div className="flexBox">
                  <div className = "problemName">{q.year+" USNCO Problem "+q.number}</div>
                        <div className="close" onClick={() => this.hideQuestion(i)}>
                            <div className="closetext">x</div>
                        </div>
                    </div>
              {individualQuestion}
          </div>
          );
      })

      const moreButton = (this.state.showAll&&this.state.topicquestions.length!==0)&&<button onClick = {this.showMore}>more</button>;

        return (
        <div>
            <div className = "row">

                <div className = "header quiz">
                {topic}
                </div>
            </div>

            <div className = "row" id="quizrow">
                <div className = "buttons column left">
                <Sidebar randomQuestion = {this.randomQuestion} showAll = {this.showAll} showPTable = {this.showPTable}/>
                
                </div>

                <div className="break" id="quizbreak"/>

                <div className = "column main">
                {this.props.PartII ? PartIIQuestions : partIQuestions}
                {moreButton}
                </div>

                <div className = {"column ptable "+this.state.PTable}>
                  <img className = {"ptableimg "+this.state.PTable} src={process.env.PUBLIC_URL + "/PTable.png"} alt="Periodic Table"/>
                </div>
            </div>
        </div>
        )
      }

}

